const yellow = {
  lightest: '#FAF5F5',
  lighter: '#F5F0F0',
  light: '#F5E6E6',
  lighten: '#E37D71',
  medium: '#E8D513',
  darken: '#665251',
  darker: '#3F1512',
  darkest: '#33110F'
}

const grey = {
  lightest: '#f2f1ed',
  lighter: '#eaeae8',
  lighten: '#adacaa',
  medium: '#adacaa',
  darker: '#40403E',
  darkest: '#161303',
}

const color = {
  yellow,
  grey
}

color.primary = yellow

export default color